import Axios from '@/utils/Axios';
import getDomainPlatform, {
  DomainPlatformValue,
} from '@/utils/getDomainPlatform';

interface RequestQuery {
  /**
   * 平台标识；fs 时写教材档案会同时把该学科标记为账号当前所在的学科
   */
  platform?: DomainPlatformValue;
}

export interface RequestData {
  /**
   * 地区代码
   */
  areaCode?: string;
  /**
   * 性别，1男 2女
   */
  gender?: number;
  /**
   * 姓名
   */
  name?: string;
  /**
   * 用户设置课
   */
  section?: number | null;
  /**
   * 用户设置单元
   */
  unit?: number | null;
  /**
   * 用户当前学科
   */
  subject?: number;
}

export default async function putProfile(
  data: RequestData,
  token?: string | null,
) {
  const platform = getDomainPlatform();

  await Axios.put(`/users/profile`, data, {
    ...(token !== undefined ? { fsSessionToken: token } : {}),
    // 「当前所在学科」只对 FS 平台生效，其他平台的请求保持不带平台标识
    params:
      platform === DomainPlatformValue.Fs
        ? ({ platform } satisfies RequestQuery)
        : undefined,
  });
}
